document.addEventListener("alpine:init", () => {
    Alpine.data("pageNav", () => ({
        open: false,
        isFixed: false,
        positionTop: 0,
        lastScrollTop: 0,
        menuHeight: 89,
        init() {
            pegasus.onResizeFinished(() => {
                setTimeout(() => {
                    this.positionTop = pegasus.getElemOffset(this.$refs.navTop);
                }, 200);
            }, true);
        },
        fix() {
            if (this.isFixed) {
                if (window.scrollY <= this.positionTop.top) {
                    this.isFixed = false;
                }
            } else {
                if (window.scrollY >= this.positionTop.top) {
                    this.isFixed = true;
                }
            }
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
    }));
});
